import { SortOrder } from '@one/web-components';
import { FieldConfig } from '../custom-table.type';
import { CustomTableSortItems } from './custom-table-sorting.model';

export const toggleSorting = (current: SortOrder): SortOrder => {
    const nextSort: Record<SortOrder, SortOrder> = {
        asc: 'desc',
        desc: 'default',
        default: 'asc',
    };
    return nextSort[current];
};

export const getSortIconVisibility = (order: SortOrder | undefined): 'hover' | 'always' =>
    (order ?? 'default') === 'default' ? 'hover' : 'always';

export const getHeaderSortOrder = <T>(
    fieldsToShow: FieldConfig<T>[],
    currentSortOrder: CustomTableSortItems,
    defaultSorting?: CustomTableSortItems
): CustomTableSortItems =>
    fieldsToShow.reduce<CustomTableSortItems>((acc, field) => {
        const filter = currentSortOrder?.[field?.name] ?? defaultSorting?.[field?.name] ?? 'default';
        if (field) {
            acc[field?.name] = filter;
        }
        return acc;
    }, currentSortOrder);
